export default "__VITE_ASSET__wkqAQJBU__"